import { CountryAlpha2 } from '../data/countryCodeMap';

export const getFlagUrl = (alpha3: string): string => {
    const key = alpha3 as keyof typeof CountryAlpha2;
    const alpha2: string | undefined = CountryAlpha2[key];
    if (!alpha2) return ''; // když stát nenajdeme
    return `https://flagcdn.com/w40/${alpha2.toLowerCase()}.png`; // velikost vlajky (změň na w80, w20 podle potřeby)
};
